export default class LocationDetails {
  constructor(container) {
    this.container = container;
    this.topElement = container.querySelector(
      '.floating-elements__sticky-mobile-buttons',
    );
  }

  topEdgePosition() {
    return this.topElement.getBoundingClientRect().height;
  }

  mount() {
    return this;
  }
}
